import { List, Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import { Fragment, memo } from 'react';

// @ts-expect-error - Remove once type definitions are available
import { getType } from '../../../common-message-format/operators/commonMessageFormatGetters';
import { TYPICAL_RESPONSE_TIME } from '../../../typical-response-time/constants/messageTypes';
// @ts-expect-error - Remove once type definitions are available
import { areMessagesGrouped } from '../../../message-history/operators/areMessagesGrouped';
// @ts-expect-error - Remove once type definitions are available
import { getAttachmentsForMessage } from '../../../message-history/operators/getAttachmentsForMessage';
// @ts-expect-error - Remove once type definitions are available
import { getMessageId } from '../../../message-history/operators/getMessageId';
// @ts-expect-error - Remove once type definitions are available
import { getPositionDescriptors } from '../../../message-history/operators/getPositionDescriptors';
// @ts-expect-error - Remove once type definitions are available
import MessageHistoryItem from './MessageHistoryItem';
import { getHiddenBy } from '../../../common-message-format/operators/commonMessageGetters';
import { jsx as _jsx } from "react/jsx-runtime";
function MessageHistoryCoreComponent({
  allowContactPromotions,
  channelName,
  fileAttachments = ImmutableMap(),
  friendlyNames,
  getAdditionalPositionDescriptors = () => ImmutableMap(),
  historyConfig,
  indexedAsyncFileAttachments,
  lastMessageId,
  legacyRecipients,
  messages,
  portalId,
  presentSenderLocators = ImmutableSet(),
  senders,
  slots,
  threadId,
  ungatedForNewForkedComponent,
  ungatedForOmnichannelCallSummaryAiSkill = false,
  ungatedForUnifiedCallSummary = false,
  vid,
  visitorLastReadTimestamp,
  visitorRecipients
}) {
  const getDontIncludeLastInGroup = (message, index) => {
    const nextNextMessage = messages === null || messages === void 0 ? void 0 : messages.get(index + 2);
    if (nextNextMessage && areMessagesGrouped(message, nextNextMessage)) {
      return true;
    }
    return false;
  };
  const additionalPositionDescriptors = getAdditionalPositionDescriptors(messages || List()) || ImmutableMap();
  return messages === null || messages === void 0 ? void 0 : messages.map((message, index) => {
    const previousMessage = index > 0 ? messages.get(index - 1) : undefined;
    const nextMessage = messages.get(index + 1);
    let dontIncludeLastInGroup;
    if (getType(nextMessage) === TYPICAL_RESPONSE_TIME) {
      dontIncludeLastInGroup = getDontIncludeLastInGroup(message, index);
    }
    const fileAttachmentsForMessage = getAttachmentsForMessage(message, fileAttachments);
    let positionDescriptors = getPositionDescriptors(message, previousMessage, nextMessage, dontIncludeLastInGroup);
    const messageId = getMessageId(message);
    const hiddenBy = getHiddenBy(message);
    positionDescriptors = positionDescriptors.merge(additionalPositionDescriptors.get(messageId, ImmutableSet()));
    return /*#__PURE__*/_jsx(Fragment, {
      children: /*#__PURE__*/_jsx(MessageHistoryItem, {
        allowContactPromotions: allowContactPromotions,
        hiddenBy: hiddenBy,
        historyConfig: historyConfig,
        fileAttachments: fileAttachmentsForMessage,
        fileAttachmentsForThread: fileAttachments,
        friendlyNames: friendlyNames,
        indexedAsyncFileAttachments: indexedAsyncFileAttachments,
        portalId: portalId,
        positionDescriptors: positionDescriptors,
        message: message,
        senders: senders,
        presentSenderLocators: presentSenderLocators,
        visitorLastReadTimestamp: visitorLastReadTimestamp,
        lastMessageId: lastMessageId,
        vid: vid,
        visitorRecipients: visitorRecipients,
        ungatedForNewForkedComponent: ungatedForNewForkedComponent,
        ungatedForOmnichannelCallSummaryAiSkill: ungatedForOmnichannelCallSummaryAiSkill,
        ungatedForUnifiedCallSummary: ungatedForUnifiedCallSummary,
        threadId: threadId,
        legacyRecipients: legacyRecipients,
        channelName: channelName,
        slots: slots
      })
    }, messageId);
  });
}
MessageHistoryCoreComponent.displayName = 'MessageHistory';
const MessageHistoryCore = /*#__PURE__*/memo(MessageHistoryCoreComponent);
export default MessageHistoryCore;